/* eslint-disable import/order */
import React, { useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useNavigate, Link } from 'react-router-dom';
import { DropdownList } from 'react-widgets';
import 'react-widgets/styles.css';
import { IoRocketOutline } from 'react-icons/io5';
import { routeNames } from 'routes';
import IdoCard from 'components/IdoCard';
import { LaunchpadType } from 'types';

import { useGetAccountInfo, useGetNetworkConfig, useGetIsLoggedIn, useGetPendingTransactions } from '@multiversx/sdk-dapp/hooks';
import { sendTransactions } from '@multiversx/sdk-dapp/services';
import { ApiNetworkProvider } from '@multiversx/sdk-network-providers';
import { Account, Address, AddressValue, ContractFunction, Interaction, ResultsParser, SmartContract, SmartContractAbi, TokenPayment, TypedValue } from '@multiversx/sdk-core';
import axios from 'axios';
import BigNumber from 'bignumber.js/bignumber';
import { contracts, ElrondApiUrl, isDev } from 'config/config';
import { BigZero, coinNames } from 'helpers/constant';
import { convertWeiToEsdt } from 'helpers/utils';

import CREATE_BUTTON from '../../assets/img/launchpad/create.png';

import './index.scss';

export const IDOLaunchpad = () => {
    const { address, account } = useGetAccountInfo();
    const isLoggedIn = useGetIsLoggedIn();
    const navigate = useNavigate();
    const { hasPendingTransactions } = useGetPendingTransactions();
    const { network } = useGetNetworkConfig();
    const networkProvider = new ApiNetworkProvider(network.apiAddress);

    const handleIDONavigate = (project_id: number) => {
        navigate(`/lauchpad/detail/${project_id}`);
    };

    // load smart contract abi and parse it to SmartContract object for tx
    const [contractInteractor, setContractInteractor] = useState<any>(undefined);
    useEffect(() => {
        (async () => {
            const { address, abi } = contracts.Launchpad;

            const contractAddress = new Address(address);
            const contractAbi = new SmartContractAbi(abi);
            const contract = new SmartContract({ address: contractAddress, abi: contractAbi });

            setContractInteractor(contract);
        })();
    }, [address]); // [] makes useEffect run once

    const [searchValue, setSearchValue] = useState<string>('');
    const [projects, setProjects] = useState<LaunchpadType[]>([]);
    const [filteredProjects, setFilteredProjects] = useState<LaunchpadType[]>([]);
    useEffect(() => {
        (async () => {
            if (!contractInteractor) return;

            try {
                const query = contractInteractor.createQuery({
                    func: new ContractFunction('getProjects'),
                    args: []
                });
                const resultsParser = new ResultsParser();
                const response = await networkProvider.queryContract(query);
                const endpointDefinition = contractInteractor.getEndpoint(
                    'getProjects'
                );
                const res = resultsParser.parseQueryResponse(
                    response,
                    endpointDefinition
                );
                const value = res.firstValue?.valueOf();
                const datas: any = [];
                value.map((item: any) => {
                    const percent: any = convertWeiToEsdt(item.project_total_fund_amount, item.project_fund_token_decimal.toNumber()).multipliedBy(100).dividedBy(convertWeiToEsdt(item.project_hard_cap, item.project_fund_token_decimal.toNumber()));
                    const data = {
                        project_id: item.project_id.toNumber(),
                        project_owner: item.project_owner.toString(),
                        project_presale_token_identifier: item.project_presale_token_identifier.toString(),
                        project_presale_token_decimal: item.project_presale_token_decimal.toNumber(),
                        project_presale_token_name: item.project_presale_token_name.toString(),
                        project_fund_token_identifier: item.project_fund_token_identifier.toString(),
                        project_fund_token_decimal: item.project_fund_token_decimal.toNumber(),
                        project_presale_token_rate: convertWeiToEsdt(item.project_presale_token_rate, item.project_presale_token_decimal.toNumber()),
                        project_create_time: item.project_create_time.toNumber() * 1000,
                        // project_soft_cap: convertWeiToEsdt(item.project_soft_cap, item.project_fund_token_decimal.toNumber()),
                        project_hard_cap: convertWeiToEsdt(item.project_hard_cap, item.project_fund_token_decimal.toNumber()),
                        project_min_buy_limit: convertWeiToEsdt(item.project_min_buy_limit, item.project_fund_token_decimal.toNumber()),
                        project_max_buy_limit: convertWeiToEsdt(item.project_max_buy_limit, item.project_fund_token_decimal.toNumber()),
                        project_presale_start_time: item.project_presale_start_time.toNumber() * 1000,
                        project_presale_end_time: item.project_presale_end_time.toNumber() * 1000,
                        project_description: item.project_description.toString(),
                        project_social_website: item.project_social_website.toString(),
                        project_social_telegram: item.project_social_telegram.toString(),
                        project_social_discord: item.project_social_discord.toString(),
                        project_social_twitter: item.project_social_twitter.toString(),
                        project_social_youtube: item.project_social_youtube.toString(),
                        project_social_linkedin: item.project_social_linkedin.toString(),
                        project_social_medium: item.project_social_medium.toString(),
                        project_is_lived: item.project_is_lived,
                        project_is_verified: item.project_is_verified,
                        project_total_fund_amount: convertWeiToEsdt(item.project_total_fund_amount, item.project_fund_token_decimal.toNumber()),
                        project_total_bought_amount: convertWeiToEsdt(item.project_total_bought_amount, item.project_presale_token_decimal.toNumber()),
                        project_buyer_count: item.project_buyer_count.toNumber(),
                        project_presale_percentage: percent.toFixed(2),
                        sc_owner_address: item.sc_owner_address.toString(),
                    };
    
                    if (data.project_is_lived) {
                        datas.push(data);
                    }
                });
                // console.log(datas);
                const waitedProject: any = [];
                const livedProjects: any = [];
                const endedProjects: any = [];
                datas.map((data: any) => {
                    if (data.project_presale_start_time > Date.now()) {
                        waitedProject.push(data);
                    } else if (Number(data.project_total_fund_amount) >= Number(data.project_hard_cap) || data.project_presale_end_time < Date.now()) {
                        endedProjects.push(data);
                    } else {
                        livedProjects.push(data);
                    }
                });
                waitedProject.sort((a: any, b: any) => {
                    return a.project_presale_start_time - b.project_presale_start_time;
                });
                livedProjects.sort((a: any, b: any) => {
                    return a.project_presale_end_time - b.project_presale_end_time;
                });
                const projects: any = [...waitedProject, ...livedProjects, ...endedProjects];
                setProjects(projects);
                setFilteredProjects(projects);
            } catch (error) {
                console.log(error);
            }
        })();
    }, [hasPendingTransactions, contractInteractor]);

    useEffect(() => {
        const filteredData = projects.filter((v: LaunchpadType) => v?.project_presale_token_identifier.toLowerCase().includes(searchValue));
        setFilteredProjects(filteredData);
    }, [searchValue]);

    const handleSortChange = (filter_type: string) => {
        let filteredData = filteredProjects;
        switch (filter_type) {
            case 'All Status':
                filteredData = projects;
                break;
            case 'Upcoming':
                filteredData = projects.filter((a: LaunchpadType) => a.project_presale_start_time > Date.now());
                break;
            case 'In progress':
                filteredData = projects.filter((a: LaunchpadType) => Date.now() > a.project_presale_start_time && a.project_presale_end_time > Date.now());
                break;
            case 'Ended':
                filteredData = projects.filter((a: LaunchpadType) => Date.now() > a.project_presale_end_time);
                break;
            case 'Sold out':
                filteredData = projects.filter((a: LaunchpadType) => Number(a.project_total_fund_amount) >= Number(a.project_hard_cap));
                break;
        }
        setFilteredProjects(filteredData);
    };
    return (
        <div className='launchpad-container'>
            <div className='home-container'>
                <div className='d-flex flex-column justify-content-center align-items-center mb-5'>
                    <span className='launchpad-title'>{'OneDex Permissionless Launchpad'}</span>

                    <div className='launchpad-description mt-4'>
                        <span>{'First decentralized IDO platform for MultiversX. Launchpad will empower crypto currency projects with the ability to distribute tokens and raise liquidity.'}</span>
                    </div>

                    <Link className='mt-5' to={isLoggedIn ? routeNames.createLaunchpad : routeNames.unlock}>
                        <img src={CREATE_BUTTON} />
                    </Link>
                </div>
            </div>
            <div className='launchpad-ido-container mt-5'>
                <div className='d-flex flex-wrap launchpad-ido-title row'>
                    <div className='col-lg-3 col-md-5 col-sm-12'>
                        <input className='launchpad-ido-input' placeholder='Enter token name or symbol' value={searchValue} onChange={(e) => setSearchValue(e.target.value)} />
                    </div>
                    <div className='col-lg-2 col-md-4 col-sm-12'>
                        <DropdownList
                            defaultValue='All Status'
                            data={['All Status', 'Upcoming', 'In progress', 'Ended', 'Sold out']}
                            onChange={handleSortChange}
                        />
                    </div>
                </div>

                <Row className='mt-5 mb-5' style={{ rowGap: '20px' }}>
                    {
                        filteredProjects.map((item: any, index: any) => {
                            return (
                                <Col key={index} md={6} lg={6} xl={6} xxl={4}>
                                    <div className='ido-box-link' onClick={() => { handleIDONavigate(item.project_id); }}>
                                        <IdoCard data={item} />
                                    </div>
                                </Col>
                            );
                        })
                    }
                </Row>
            </div>
        </div>
    );
};
